import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dbda029"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_7 = {
  class: "ant-row",
  style: {"padding-top":"5px"}
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { class: "ss-margin-campos ss-sombra-suave" }
const _hoisted_10 = { style: {"margin-top":"10px","margin-left":"5px","margin-bottom":"0px"} }
const _hoisted_11 = { style: {"padding-top":"5px"} }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Natureza")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-10 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Número")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-11" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Nome")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-10 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Reduzida")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1))
const _hoisted_15 = {
  key: 1,
  class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_17 = { class: "ss-margin-campos" }
const _hoisted_18 = { class: "ant-col ant-col-xs-10 ant-col-xl-4" }
const _hoisted_19 = { class: "ss-margin-campos" }
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-11" }
const _hoisted_21 = { class: "ss-margin-campos" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "ant-col ant-col-xs-6 ant-col-xl-3" }
const _hoisted_24 = { class: "ss-margin-campos ss-alinhar-texto-centro" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_26 = { class: "acoes-item" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_plano_conta = _resolveComponent("selecionar-tipo-plano-conta")!
  const _component_apresentar_nivel_plano_contas = _resolveComponent("apresentar-nivel-plano-contas")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_plano_conta_categoria_modal = _resolveComponent("plano-conta-categoria-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    centered: "",
    width: 900,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Cadastro de Plano de Contas "),
      _createVNode(_component_a_switch, {
        checked: _ctx.state.planoContas.ativo,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.planoContas.ativo) = $event)),
        style: {"float":"right"},
        "checked-children": "Ativa",
        "un-checked-children": "Inativa"
      }, null, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                  || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    tab: _ctx.state.planoContas.codigo > 0 ? 'Dados Principais' : '',
                    key: "1"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_a_form_item, {
                            label: "Empresas",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_empresa, {
                                varias: true,
                                empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                "onUpdate:codigosSelecionados": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                              }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, _ctx.telaBase.apresentarEmpresas]
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_plano_conta, {
                                valor: _ctx.state.planoContas.tipo,
                                "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.planoContas.tipo) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_a_form_item, {
                            label: "Descrição",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "250",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.planoContas.descricao) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.planoContas.descricao]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_card, { titulo: "Formatação da Máscara do Plano de Contas" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.planoContas.niveis, (nivel, index) => {
                                return (_openBlock(), _createBlock(_component_apresentar_nivel_plano_contas, {
                                  key: index,
                                  indice: index,
                                  nivel: _ctx.state.planoContas.niveis[index],
                                  "onUpdate:nivel": ($event: any) => ((_ctx.state.planoContas.niveis[index]) = $event),
                                  onRemoverNivel: ($event: any) => (_ctx.removerNivel(index)),
                                  onValorAtualizado: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formatarMascara()))
                                }, null, 8, ["indice", "nivel", "onUpdate:nivel", "onRemoverNivel"]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-block",
                                  style: {"min-height":"40px"},
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.adicionarNivel()))
                                }, [
                                  _createVNode(_component_icone, {
                                    style: {"font-size":"18px","margin-top":"5px"},
                                    nome: "novo"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("h3", null, "Máscara: " + _toDisplayString(_ctx.state.mascaraFormatada), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  ((_ctx.state.planoContas.codigo > 0))
                    ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                        tab: "Categorias",
                        key: "2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-lg ss-sombra-suave ss-tamanho-completo ss-margem-inferior-20",
                              title: "Criar Conta",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.criarCategoria()))
                            }, [
                              _createVNode(_component_icone, { nome: "novo" }),
                              _createTextVNode(" Nova Categoria ")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_a_form_item, {
                                label: "Pesquisar",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.filtroCategorias) = $event)),
                                    placeholder: "Digite o número ou nome da categoria que você deseja pesquisar...",
                                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filtrarCategorias()))
                                  }, null, 544), [
                                    [_vModelText, _ctx.state.filtroCategorias]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode(_component_a_skeleton, {
                            loading: _ctx.state.carregandoCategorias
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14,
                              (_ctx.state.planoContas.categorias.length <= 0)
                                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                    key: 0,
                                    mensagem: "Nenhuma categoria foi encontrada"
                                  }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.planoContas.categorias, (categoria, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "ant-row ss-grade-personalizada-linha",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("span", null, _toDisplayString(categoria.natureza === 'C' ? 'Crédito': 'Débito'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("span", null, _toDisplayString(categoria.numero), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_20, [
                                          _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("a", {
                                              title: "Visualizar Categoria",
                                              onClick: ($event: any) => (_ctx.editarCategoria(categoria.codigo))
                                            }, _toDisplayString(categoria.nome), 9, _hoisted_22)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("span", null, _toDisplayString(categoria.contaReduzida > 0?categoria.contaReduzida:''), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("a", {
                                              title: "Editar",
                                              class: "visualizar",
                                              onClick: ($event: any) => (_ctx.editarCategoria(categoria.codigo))
                                            }, [
                                              _createVNode(_component_icone, { nome: "visualizar" })
                                            ], 8, _hoisted_27),
                                            _createElementVNode("a", {
                                              title: "Duplicar",
                                              class: "visualizar",
                                              onClick: ($event: any) => (_ctx.duplicarCategoria(categoria.codigo))
                                            }, [
                                              _createVNode(_component_icone, { nome: "duplicar" })
                                            ], 8, _hoisted_28),
                                            (categoria.tipo === 'S')
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  title: "Criar Categoria Filha",
                                                  class: "visualizar",
                                                  onClick: ($event: any) => (_ctx.criarCategoriaFilha(categoria.codigo))
                                                }, [
                                                  _createVNode(_component_icone, { nome: "mais" })
                                                ], 8, _hoisted_29))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("a", {
                                              title: "Excluir",
                                              onClick: ($event: any) => (_ctx.excluirCategoria(categoria.codigo, categoria.nome)),
                                              class: "excluir"
                                            }, [
                                              _createVNode(_component_icone, { nome: "excluir" })
                                            ], 8, _hoisted_30)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_plano_conta_categoria_modal, {
        visivel: _ctx.state.exibirModalCategoria,
        "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.exibirModalCategoria) = $event)),
        planoContas: _ctx.state.planoContas.codigo,
        mascaraPlanoContas: _ctx.state.planoContas.mascara,
        operacao: _ctx.state.operacaoCategoria,
        onSincronizarRegistro: _cache[12] || (_cache[12] = ($event: any) => (_ctx.obterCategorias()))
      }, null, 8, ["visivel", "planoContas", "mascaraPlanoContas", "operacao"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}